<div class="dialog-container">
  <h2 mat-dialog-title>Record Loan Payment</h2>
  <div mat-dialog-content>
    <p class="dialog-message">
      Enter the payment details for loan: <strong>{{ data.loan.name }}</strong>
    </p>
    
    <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Payment Date</mat-label>
        <input 
          matInput 
          [matDatepicker]="picker" 
          formControlName="date"
          required>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if(paymentForm.get('date')?.hasError('required')) {
          <mat-error>
            Date is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Payment Amount</mat-label>
        <input 
          matInput 
          type="text" 
          formControlName="payment" 
          required numberFormat>
        <span matPrefix>&nbsp;$&nbsp;</span>
        @if(paymentForm.get('payment')?.hasError('required')) {
          <mat-error>
            Amount is required
          </mat-error>
        }
        @if(paymentForm.get('payment')?.hasError('min')) {
          <mat-error>
            Amount must be greater than $0.01
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Principal</mat-label>
        <input 
          matInput 
          type="text" 
          formControlName="principal" 
          required numberFormat>
        <span matPrefix>&nbsp;$&nbsp;</span>
        @if(paymentForm.get('principal')?.hasError('required')) {
          <mat-error>
            Principal is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Interest</mat-label>
        <input 
          matInput 
          type="text" 
          formControlName="interest" 
          required numberFormat
          readonly>
        <span matPrefix>&nbsp;$&nbsp;</span>
        <mat-hint>Interest amount is fixed based on the loan terms</mat-hint>
        @if(paymentForm.get('interest')?.hasError('required')) {
          <mat-error>
            Interest is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Late Fee</mat-label>
        <input 
          matInput 
          type="text" 
          formControlName="late_fee" 
          required numberFormat>
        <span matPrefix>&nbsp;$&nbsp;</span>
        @if(paymentForm.get('late_fee')?.hasError('required')) {
          <mat-error>
            Late fee is required (enter 0 if none)
          </mat-error>
        }
      </mat-form-field>
      

    </form>
  </div>
  
  <div mat-dialog-actions align="end">
    <button 
      mat-button 
      type="button" 
      [disabled]="loading" 
      (click)="onCancel()">
      Cancel
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      type="submit" 
      [disabled]="paymentForm.invalid || loading" 
      (click)="onSubmit()">
      @if(loading) {
        <span>Processing...</span>
      } @else {
        <span>Record Payment</span>
      }
    </button>
  </div>
</div>
